var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrinter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.207 27.9062H7.79297L5.56641 36.8125H32.4336L30.207 27.9062Z",
    fill: "#D7181D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5273 7.86722H29.5547L23.5273 1.83984V7.86722Z",
    fill: "#D7181D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79297 1.1875V16.7734H30.207V10.0938H21.3008V1.1875H7.79297Z",
    fill: "#D7181D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6602 12.3203H32.4336V16.7734H34.6602V19C32.7936 19 5.13816 19 3.33984 19V16.7734H5.56641V12.3203H3.33984C1.49818 12.3203 0 13.8185 0 15.6602V32.3594H4.38462L6.05454 25.6797H31.9455L33.6154 32.3594H38V15.6602C38 13.8185 36.5018 12.3203 34.6602 12.3203ZM29.0938 23.4531H26.8672V21.2266H29.0938V23.4531ZM33.5469 23.4531H31.3203V21.2266H33.5469V23.4531Z",
    fill: "#D7181D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter);
export default __webpack_public_path__ + "static/media/icon-printer.bf1fa4ec051cbda13fbb2825501e1b49.svg";
export { ForwardRef as ReactComponent };